import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks = {
  categories: [
    { label: "RPG Quizzes", href: "/categories?cat=rpg" },
    { label: "Anime Quizzes", href: "/categories?cat=anime" },
    { label: "Sandbox Games", href: "/categories?cat=sandbox" },
    { label: "Movies", href: "/categories?cat=movies" },
    { label: "Entertainment", href: "/categories?cat=entertainment" },
  ],
  trending: [
    { label: "Toca Boca", href: "/categories?tag=toca-boca" },
    { label: "Roblox", href: "/categories?tag=roblox" },
    { label: "Disney", href: "/categories?tag=disney" },
    { label: "Avatar World", href: "/categories?tag=avatar-world" },
    { label: "Minecraft", href: "/categories?tag=minecraft" },
  ],
  company: [
    { label: "About Us", href: "/about" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Use", href: "/terms" },
    { label: "Write For Us", href: "/write-for-us" },
    { label: "Feedback", href: "/feedback" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d716171lum2co2q1fgr0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#1A1A1A] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand + Newsletter */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53]">
                <i className="ri-gamepad-fill text-white text-sm" />
              </div>
              <span
                className="font-extrabold text-xl text-white"
                style={{ fontFamily: "'Nunito', sans-serif" }}
              >
                Funs<span className="text-[#FFE066]">Test</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              The internet&apos;s most fun quiz destination. Discover your personality, share your results, and connect with millions of quiz lovers!
            </p>

            <div className="mb-4">
              <p className="text-sm font-bold text-white mb-1">
                🔥 Don&apos;t miss our weekly quizzes!
              </p>
              <p className="text-xs text-gray-400 mb-3">
                Join 2M+ subscribers getting fresh quizzes every week.
              </p>
            </div>

            {submitted ? (
              <div className="flex items-center gap-2 text-[#2DD4BF] text-sm font-semibold">
                <i className="ri-checkbox-circle-fill text-lg" />
                You&apos;re in! Check your inbox
              </div>
            ) : (
              <form
                onSubmit={handleSubscribe}
                data-readdy-form
                id="newsletter-footer"
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-[#FF6B6B] transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-5 py-2.5 bg-[#FF6B6B] hover:bg-[#ff5252] text-white text-sm font-bold rounded-full transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitting ? "..." : "Subscribe"}
                </button>
              </form>
            )}
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-[#FF6B6B] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Trending */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Trending Tags
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.trending.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-[#FF6B6B] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-[#FF6B6B] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            &copy; 2026 FunsTest. All rights reserved. Made with 💖 for quiz lovers everywhere.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://pinterest.com"
              rel="nofollow noreferrer"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B6B] transition-colors cursor-pointer text-white"
            >
              <i className="ri-pinterest-fill text-sm" />
            </a>
            <a
              href="https://tiktok.com"
              rel="nofollow noreferrer"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B6B] transition-colors cursor-pointer text-white"
            >
              <i className="ri-tiktok-fill text-sm" />
            </a>
            <a
              href="https://facebook.com"
              rel="nofollow noreferrer"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B6B] transition-colors cursor-pointer text-white"
            >
              <i className="ri-facebook-fill text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
